export default __webpack_public_path__ + "static/media/JOSA CLASS-8 EXAM PATTERN 2026-27.936814b6.pdf";